import $axios from '@/core/api-config'

class ProjectService {
  getById (id) {
    return $axios.get(`/api/projects/project/${id}`)
  }

  getAll () {
    return $axios.get('/api/projects/')
  }

  getDeleted () {
    return $axios.get('/api/projects/deleted')
  }

  add (data) {
    return $axios.post('/api/projects/', data)
  }

  delete (id) {
    return $axios.delete(`/api/projects/${id}`, { data: { permanent: false } })
  }

  permanentDelete (id) {
    return $axios.delete(`/api/projects/${id}`, { data: { permanent: true } })
  }

  edit (id, data) {
    return $axios.put(`/api/projects/${id}`, data)
  }

  editSharedProject (projectId, shareId, data) {
    return $axios.put(`/api/projects/${projectId}/${shareId}`, data)
  }

  restore (id) {
    return $axios.post(`/api/projects/restore/${id}`)
  }

  getSharedProject (projectId, shareId) {
    return $axios.get(`api/projects/${projectId}/${shareId}`)
  }

  getShareByProjectId (id) {
    return $axios.get(`api/share/project/${id}`)
  }

  getShare (id) {
    return $axios.get(`/api/share/${id}`)
  }

  postShare (data) {
    return $axios.post(`/api/share/${data.projectId}`, data)
  }

  send (data) {
    return $axios.post('/api/projects/email', data)
  }

  sendShared (data) {
    return $axios.post('/api/projects/email/share', data)
  }

  order (ids) {
    return $axios.post('/api/projects/order/', { ids })
  }

  exportDocx (id) {
    return $axios.get(`/api/projects/export/docx/${id}`)
  }

  exportPdf (id) {
    return $axios.get(`/api/projects/export/pdf/${id}`, { responseType: 'blob' })
  }

  exportSharedProjectAsPdf (id, shareId) {
    return $axios.get(`/api/projects/export/pdf/${id}/${shareId}`, { responseType: 'blob' })
  }

  exportSharedProjectAsDocx (id, shareId) {
    return $axios.get(`/api/projects/export/docx/${id}/${shareId}`)
  }

  getSize (id) {
    return $axios.get(`/api/projects/size/${id}`)
  }

  getSizeOfSharedProject (id, shareId) {
    return $axios.get(`/api/projects/size/${id}/${shareId}`)
  }
}

export const projectService = new ProjectService()
